import { defineMessages } from "react-intl";

import {
	validator,
	valueMessages
} from "lib/build/forms/htx/medical-history/heartFailureEtiology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	heartFailureEtiology: {
		id: "form.heart_failure_etiology",
		defaultMessage: "Szívelégtelenség etiológiája"
	},
	value: {
		id: "form.heart_failure_etiology.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: valueMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "heartFailureEtiology",
	value: {
		title: messages.heartFailureEtiology,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
